/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Text } from 'components';
import { Content, LayoutCircle, Section, Spacer } from './styles';
import { useGetOperationNavigation } from '../../services/OperationService';
import { LoaderContext } from '../../contexts';

const StepNavigation = ({ idOperation, stage }) => {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const nextStage = useRef(null)

  const history = useHistory();
  const defaultRouteStep1 = (idOperation) => `/edit-quote/${idOperation}`;
  const defaultRouteStep2 = (idOperation) => `/markets-management/${idOperation}`;

  const {
    data: useGetOperationNavigationData,
    loading: useGetOperationNavigationLoading,
    error: useGetOperationNavigationError,
    status: useGetOperationNavigationStatus,
    request: useGetOperationNavigationRequest,
  } = useGetOperationNavigation(idOperation);

  useEffect(() => {
    updateIsLoadingStatus(
      useGetOperationNavigationLoading);
  }, [useGetOperationNavigationLoading]);

  useEffect(() => {
    if (useGetOperationNavigationStatus === 200) {
      if (useGetOperationNavigationData.value?.route) {
        const { route, step, operation } = useGetOperationNavigationData.value;

        const idQuotationOperation = operation?.operationMetadata?.idQuotationOperation;
        if (nextStage.current === 2 && step === 3) return history.push(defaultRouteStep2(idQuotationOperation || idOperation));
        if (nextStage.current === 1 && step !== 1) return history.push(defaultRouteStep1(idQuotationOperation || idOperation));

        history.push(route);
      }
    }
  }, [useGetOperationNavigationStatus]);

  return (
    <>
      <Content>
        <Section>
          <LayoutCircle isActive={stage === 1}
            onClick={() => {
              nextStage.current = 1;
              useGetOperationNavigationRequest()
            }}>
            1
          </LayoutCircle>
          <Text className="d-none d-sm-block" spaceLeft={true} >ENQUIRY</Text>
        </Section>

        <Spacer className="d-sm-none"></Spacer>
        <Section>
          <LayoutCircle
            isActive={stage === 2} onClick={() => {
              nextStage.current = 2;
              useGetOperationNavigationRequest()
            }}>
            2
          </LayoutCircle>
          <Text className="d-none d-sm-block" spaceLeft={true}>BROKING</Text>
        </Section>

        <Spacer className="d-sm-none"></Spacer>
        <Section>
          <LayoutCircle isActive={stage === 3} onClick={() => {
            nextStage.current = 3;
            useGetOperationNavigationRequest()
          }}>
            3
          </LayoutCircle>
          <Text className="d-none d-sm-block" spaceLeft={true}>BINDING</Text>
        </Section>
      </Content>
    </>
  )
}

export default StepNavigation;